import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Editor, Range } from 'slate';

// modified on the basic of the slate function Editor.nodes
// todo: get the node which nearest to the selection
var getNodesByTypeAtRange = function getNodesByTypeAtRange(editor, type) {
  var match = {};
  if (Array.isArray(type)) {
    match.match = type;
  } else {
    match.match = {
      type: type
    };
  }
  var nodes = Editor.nodes(editor, match);
  var _Editor$nodes = Editor.nodes(editor, {
      match: 'block'
    }),
    _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
    blockNode = _Editor$nodes2[0];
  var listItemDepth = blockNode[1].length - 1;
  if (Range.isCollapsed(editor.selection)) {
    var node;
    var _iterator = _createForOfIteratorHelper(nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        node = item;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return node;
  } else {
    var itemsWithSameAncesstor = [];
    var _iterator2 = _createForOfIteratorHelper(nodes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _node = _step2.value;
        if (listItemDepth === _node[1].length) {
          itemsWithSameAncesstor.push(_node);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return itemsWithSameAncesstor;
  }
};
export default getNodesByTypeAtRange;